import axios from "axios";
import BaseApi from "./baseApi";
export default class StorageApi extends BaseApi {
  constructor(organizationCode) {
    super(organizationCode);
  }

  uploadFile(file) {
    const data = new FormData();
    data.append("file", file);
    return axios.post(this.url + "/storage-api/contents", data).then(response => {
      if (response && response.data) return response.data;
      else return null;
    });
  }
}
